const React = require('react');
const { createElement: h, useState } = React;
const apiClient = require('../lib/apiClient');
require('./ExtensionAuthNotice.css');

function ExtensionAuthNotice(props) {
  var code = readAuthorizationCode();
  var [reviewing, setReviewing] = useState(!!code);
  var [dismissed, setDismissed] = useState(false);
  var [busy, setBusy] = useState(false);
  var [error, setError] = useState('');
  var [approvedDevice, setApprovedDevice] = useState('');

  if (!code || dismissed) return null;

  function approve() {
    setBusy(true);
    setError('');
    apiClient.request('/extension-auth/device/approve', {
      method: 'POST',
      body: { userCode: code }
    }).then(function(result) {
      setApprovedDevice((result && result.deviceName) || 'Chrome extension');
    }).catch(function(requestError) {
      setError(requestError && requestError.message ? requestError.message : 'Could not approve this device.');
    }).finally(function() {
      setBusy(false);
    });
  }

  function closeRequest() {
    window.history.replaceState({}, '', '/dashboard');
    setDismissed(true);
  }

  return h(React.Fragment, null,
    h('aside', { className: 'extension-auth-notice', role: 'status' },
      h('span', { className: 'extension-auth-notice-dot', 'aria-hidden': 'true' }),
      h('div', null,
        h('strong', null, 'Chrome extension approval requested'),
        h('span', null, 'Review code ' + code)
      ),
      h('button', { type: 'button', onClick: function() { setReviewing(true); } }, 'Review'),
      h('button', { type: 'button', className: 'extension-auth-notice-dismiss', onClick: closeRequest, 'aria-label': 'Dismiss' }, '×')
    ),
    reviewing ? h('div', { className: 'extension-auth-modal-backdrop', role: 'presentation' },
      h('section', { className: 'extension-auth-modal', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'extension-auth-modal-title' },
        h('div', { className: 'extension-auth-modal-icon', 'aria-hidden': 'true' }, approvedDevice ? '✓' : '↪'),
        h('p', { className: 'extension-auth-modal-eyebrow' }, approvedDevice ? 'Device connected' : 'Browser Engine'),
        h('h2', { id: 'extension-auth-modal-title' }, approvedDevice ? 'Chrome is connected' : 'Approve this Chrome extension?'),
        approvedDevice
          ? h('p', null, approvedDevice + ' can now run your Browser Action workflows. Reopen the extension popup to continue.')
          : h(React.Fragment, null,
              h('p', null, 'Confirm that this code matches the code requested by your Alleflow extension. Your password is never shared.'),
              h('div', { className: 'extension-auth-modal-code' }, code),
              h('div', { className: 'extension-auth-modal-permissions' },
                h('strong', null, 'This device can:'),
                h('span', null, 'Read and import Browser Action workflows'),
                h('span', null, 'Run, pause, resume, and stop workflows'),
                h('span', null, 'Control Browser Action steps in this Chrome device')
              ),
              h('div', { className: 'extension-auth-modal-account' },
                h('span', null, 'Approving as'),
                h('strong', null, accountName(props.currentUser))
              )
            ),
        error ? h('div', { className: 'extension-auth-modal-error', role: 'alert' }, error) : null,
        h('div', { className: 'extension-auth-modal-actions' },
          approvedDevice
            ? h('button', { type: 'button', className: 'primary', onClick: closeRequest }, 'Done')
            : h(React.Fragment, null,
                h('button', { type: 'button', onClick: function() { setReviewing(false); }, disabled: busy }, 'Not now'),
                h('button', { type: 'button', className: 'primary', onClick: approve, disabled: busy }, busy ? 'Approving…' : 'Approve device')
              )
        )
      )
    ) : null
  );
}

function readAuthorizationCode() {
  if (typeof window === 'undefined') return '';
  var value = new URLSearchParams(window.location.search).get('extension-auth-code') || '';
  var compact = String(value).toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 8);
  return compact.length === 8 ? compact.slice(0, 4) + '-' + compact.slice(4) : '';
}

function accountName(user) {
  return (user && (user.username || user.email)) || 'Alleflow account';
}

module.exports = ExtensionAuthNotice;
